import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FooterLabel_EN } from 'src/app/models/labels/footerLabel_EN';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  label: FooterLabel_EN;

  constructor(public dialogRef: MatDialogRef<AboutUsComponent>) { }

  ngOnInit() {
    this.label = new FooterLabel_EN();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
